var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SettingPanel',{attrs:{"title":"SLA timeout","loading":_vm.isLoading},scopedSlots:_vm._u([{key:"edit",fn:function(ref){
var done = ref.done;
return [_c('SlaManagement',{attrs:{"setting":_vm.data},on:{"updateSetting":function($event){_vm.data = $event},"onClose":function($event){return done()}}})]}}])},[_vm._v("\n\n  "+_vm._s(_vm.data.ticket_agent_sla_time)+" Sec\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5976d619","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/ticket3/ticket-management/Setting/SlaTimeout.vue
// module id = null
// module chunks = 